import type React from "react";
import { BarChart3, Calendar, Coffee, DollarSign, Package, User } from "lucide-react";

/** The prompts the composer and the empty state offer.
 *
 * `complete: false` marks a prompt that is a beginning, not a question: it is
 * offered where it can be edited (the composer) and never where a click would
 * send it as it stands (the empty state). */
export type QuickAction = {
  id: string;
  label: string;
  prompt: string;
  icon: React.ElementType;
  complete: boolean;
};

export const QUICK_ACTIONS: readonly QuickAction[] = [
  { id: "agenda", label: "Agenda de hoje", prompt: "Como está a agenda de hoje?", icon: Calendar, complete: true },
  { id: "paciente", label: "Buscar paciente", prompt: "Buscar informações do paciente ", icon: User, complete: false },
  { id: "faturamento", label: "Faturamento do dia", prompt: "Qual o faturamento de hoje?", icon: DollarSign, complete: true },
  { id: "estoque", label: "Estoque", prompt: "Verificar estoque", icon: Package, complete: true },
  { id: "metricas", label: "Métricas", prompt: "Quais são as métricas do dashboard?", icon: BarChart3, complete: true },
  { id: "briefing", label: "Briefing matinal", prompt: "Faça meu briefing matinal", icon: Coffee, complete: true },
];

/** The subset the empty state sends on a single click. */
export const SENDABLE_QUICK_ACTIONS = QUICK_ACTIONS.filter((action) => action.complete);
